<script>
export default {
  methods: {
    setGlobalLoading(active) {
      this.$store.commit('LOADING', active)
    },
  },
}
</script>
